import React from "react"
import "./wave.css"

const ReverseWave = () => {
  return (
    <section
      style={{
        height: "120px",
        // width: "100%",
        transform: "rotate(180deg) scaleX(-1)",
      }}
    >
      <div
        className="wave wave1"
        style={{ animationDirection: "reverse" }}
      ></div>
      <div
        className="wave wave2"
        style={{ animationDirection: "reverse" }}
      ></div>
      <div
        className="wave wave3"
        style={{ animationDirection: "reverse" }}
      ></div>
      <div
        className="wave wave4"
        style={{ animationDirection: "reverse" }}
      ></div>
    </section>
  )
}
export default ReverseWave
